import { IconWrapper } from '../runtime';
export default IconWrapper('future-build-two', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M4 44H44",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("ellipse", {
    "attrs": {
      "cx": "24.5",
      "cy": "7",
      "rx": "13.5",
      "ry": "3",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }), h("path", {
    "attrs": {
      "d": "M16 9C16 9 20.1593 17.8828 21 24C22.0687 31.7763 20 44 20 44",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }), h("path", {
    "attrs": {
      "d": "M32.2261 9C32.2261 9 28.0668 17.8828 27.2261 24C26.1574 31.7763 28.0001 44 28.0001 44",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  })]);
});